<template>
  <div id="ultra-frame" :style="`background-color:${bg}`">
    <div id="ultra-container">
      <!-- HEADER -->
      <SubpageHeader
        :is_sticky="true"
        :background_color="bg"
        :foreground_color="fg"
        @backBtnClicked="test()"
      >
        <template #rightside>
          <!-- SEARCH -->
          <SearchBar
            :background_color="bg"
            :foreground_color="fg"
            :is_live_emit="true"
            @search="search_term=$event || ''"
          />
        </template>
        <template #below>
          <div class="work-package-qr-filter-container">
            <!-- SELECT FILTER -->
            <DropDown
              :items="search_filter_items"
              :default_item="'Latest'"
              :placeholder="'Filter'"
              :max_width="120"
              :background_color="bg"
              :foreground_color="fg"
              :light="is_light_mode(fg)"
              @selected="search_filter_selected=$event"
            />
          </div>
        </template>
      </SubpageHeader>

      <div class="work-package-qr-container">
        <!-- QR LIST -->
          <WorkPackageQrList
            :categorized_qr_codes="categorized_qr_codes"
            :background_color="bg"
            :foreground_color="fg"
            @emittedClick="handleClickEvent($event)"
          />
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue';
import DropDown from '@/components/WorkPackageWIP/DropDown.component.vue';
import WorkPackageQrList from '@/modules/WorkPackageWIP/WorkPackageQrList.module.vue';
import SubpageHeader from '@/modules/WorkPackageWIP/SubpageHeader.module.vue';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';

  export default {
    components: {
      SearchBar,
      DropDown,
      WorkPackageQrList,
      SubpageHeader,
    },

    mixins: [
      WorkPackageWIPMixin,
    ],

    computed: {
      sorted_qr_codes() {
        let ret = this.qr_codes;
        let sort_key;
        let is_reversed;

        if(this.search_filter_selected == 'Latest') {
          ret = ret.filter(qr =>
            qr.description.toLowerCase().includes(this.search_term.toLowerCase()) ||
            qr.date.toLowerCase().includes(this.search_term.toLowerCase()) ||
            qr.pers.first_name.toLowerCase().includes(this.search_term.toLowerCase()) ||
            qr.pers.last_name.toLowerCase().includes(this.search_term.toLowerCase())
          );
          sort_key = 'date';
          is_reversed = true;
        }
        else if(this.search_filter_selected == 'Description') {
          ret = ret.filter(qr => qr.description.toLowerCase().includes(this.search_term.toLowerCase()));
          sort_key = 'description';
        }
        else if(this.search_filter_selected == 'Date') {
          ret = ret.filter(qr => qr.date.toLowerCase().includes(this.search_term.toLowerCase()));
          sort_key = 'date';
          is_reversed = true;
        }
        else if(this.search_filter_selected == 'Person') {
          ret = ret.filter(qr => qr.person_string.toLowerCase().includes(this.search_term.toLowerCase()));
          sort_key = 'person_string';
        }

        this.sortObjectArrayByValueOfKey(ret, sort_key);

        // important for dates
        if(is_reversed) {
          ret.reverse();
        }
        return ret;
      },

      categorized_qr_codes() {
        let qr_code_arr = [];
        let arr_idx = -1;

        if(!this.sorted_qr_codes.length) {
          return [];
        }

        switch (this.search_filter_selected) {
          case 'Description':
            for(let i = 0; i < this.sorted_qr_codes.length; i++) {
              if(
                qr_code_arr[arr_idx] &&
                this.sorted_qr_codes[i].description[0].toUpperCase() === qr_code_arr[arr_idx].category
              ) {
                qr_code_arr[arr_idx].data.push(this.sorted_qr_codes[i]);
              }
              else {
                arr_idx++;
                qr_code_arr.push({
                  category: this.sorted_qr_codes[i].description[0].toUpperCase(),
                  data: [this.sorted_qr_codes[i]]
                });
              }
            }
            return qr_code_arr;

          case 'Date':
            for(let i = 0; i < this.sorted_qr_codes.length; i++) {
              if(
                qr_code_arr[arr_idx] &&
                this.sorted_qr_codes[i].date_string === qr_code_arr[arr_idx].category
              ) {
                qr_code_arr[arr_idx].data.push(this.sorted_qr_codes[i]);
              }
              else {
                arr_idx++;
                qr_code_arr.push({
                  category: this.sorted_qr_codes[i].date_string,
                  data: [this.sorted_qr_codes[i]]
                });
              }
            }
            return qr_code_arr;

          case 'Person':
            for(let i = 0; i < this.sorted_qr_codes.length; i++) {
              if(
                qr_code_arr[arr_idx] &&
                this.sorted_qr_codes[i].person_string === qr_code_arr[arr_idx].category
              ) {
                qr_code_arr[arr_idx].data.push(this.sorted_qr_codes[i]);
              }
              else {
                arr_idx++;
                qr_code_arr.push({
                  category: this.sorted_qr_codes[i].person_string,
                  data: [this.sorted_qr_codes[i]]
                });
              }
            }
            return qr_code_arr;
          default:
            return [{ category: '', data: this.sorted_qr_codes }];
        }
      },
    },

    data: () => ({
      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',

      is_edit: false,

      search_term: '',

      qr_codes: [
        { id: 1, description: 'EEEEEEEEEE', date: '2021-12-23 07:07:27 UTC', pers: { first_name: 'Narko', last_name: 'Wegrollt' }, },
        { id: 2, description: 'EFEEEEEEEE', date: '2021-12-23 08:07:27 UTC', pers: { first_name: 'Marco', last_name: 'Herold' }, },
        { id: 3, description: 'FFFFFFFFFF', date: '2021-12-23 09:07:27 UTC', pers: { first_name: 'Marco', last_name: 'Herold' }, },
        { id: 4, description: 'G1G1G1G1G1', date: '2021-12-23 10:07:27 UTC', pers: { first_name: 'Narko', last_name: 'Wegrollt' }, },
        { id: 5, description: 'ZZZXXXYYYA', date: '2021-12-23 11:07:27 UTC', pers: { first_name: 'Marco', last_name: 'Herold' }, },
        { id: 6, description: 'AAAAAAAAAA', date: '2021-12-23 12:07:27 UTC', pers: { first_name: 'Yusao', last_name: 'Zeroten-Powerspike' }, },
      ],

      search_filter_selected: 'Latest',
      search_filter_items: [
        'Latest', 'Description', 'Date', 'Person',
      ],
    }),

    methods: {
      test() {
      },

      handleClickEvent() {
      },
    },

    mounted() {
      let date;
      let date_string;
      for(let i = 0; i < this.qr_codes.length; i++) {
        this.qr_codes[i].person_string = `${this.qr_codes[i].pers.last_name}, ${this.qr_codes[i].pers.first_name}`;

        date = new Date(this.qr_codes[i].date.split(' UTC')[0]);
        date_string = '';
        date_string += this.getWeekdayString(date.getDay());
        date_string += ', ';
        date_string += date.getDate();
        date_string += '. ';
        date_string += this.getMonthString(date.getMonth());
        date_string += ' ';
        date_string += date.getFullYear();

        this.qr_codes[i].date_string = date_string;
      }
    },
  }
</script>

<style>
  #ultra-frame {
    width: 100%;
    height: calc(100% - 48px) !important;
  }
  #ultra-container {
    margin: 0 10px;
  }
  .work-package-qr-filter-container {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 10px;
  }
  .work-package-qr-container {
    position: relative;
  }
  .work-package-qr-display-buttons {
    display: flex;
    flex-direction: row;
    grid-gap: 8px;
  }
</style>
